import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TableDataService } from '../common/services/table-data-service';
import { Store } from '@ngrx/store';
import { OPEN_ALL_SECTIONS } from '../store/user';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { GraphModalComponent } from '../table-components/graph-modal/graph-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'states',
  templateUrl: './states.component.html',
  styleUrls: ['./states.component.css']
})
export class StatesComponent implements OnInit, OnDestroy {
  // Table Header with Expand button
  header: string = 'State';
  fullScreenMode: boolean = false;
  subHeader: string;

  // At a Glance Paragraph
  paragraphText: string = '';

  // Dark Blue Overview Header
  overviewHeaderOpen = true;

  // Table data
  table6Overview;
  table6TotalFacilitySection;
  table6HospitalUnitSection;
  table6CommunityHealthIndicators;

  // Show/Hide tables
  overViewTableOpen = true;
  totalFacilityTableOpen = true;
  hospitalUnitTableOpen = true;
  communityHealthTableOpen = true;
  tableControlsOpen: boolean = true;

  // Years Displayed
  yearsToDisplay = [
    { abbr: '2013', checked: false },
    { abbr: '2014', checked: false },
    { abbr: '2015', checked: false },
    { abbr: '2016', checked: false },
    { abbr: '2017', checked: false },
    { abbr: '2018', checked: true },
    { abbr: '2019', checked: true },
    { abbr: '2020', checked: true },
    { abbr: '2021', checked: true },
    { abbr: '2022', checked: true }
  ];

  // Current table used to add remove/year
  default_response;

  // States for dropdown
  states = [
    { abbr: 'AL', name: 'Alabama' },
    { abbr: 'AK', name: 'Alaska' },
    { abbr: 'AZ', name: 'Arizona' },
    { abbr: 'AR', name: 'Arkansas' },
    { abbr: 'CA', name: 'California' },
    { abbr: 'CO', name: 'Colorado' },
    { abbr: 'CT', name: 'Connecticut' },
    { abbr: 'DE', name: 'Delaware' },
    { abbr: 'DC', name: 'District Of Columbia' },
    { abbr: 'FL', name: 'Florida' },
    { abbr: 'GA', name: 'Georgia' },
    { abbr: 'HI', name: 'Hawaii' },
    { abbr: 'ID', name: 'Idaho' },
    { abbr: 'IL', name: 'Illinois' },
    { abbr: 'IN', name: 'Indiana' },
    { abbr: 'IA', name: 'Iowa' },
    { abbr: 'KS', name: 'Kansas' },
    { abbr: 'KY', name: 'Kentucky' },
    { abbr: 'LA', name: 'Louisiana' },
    { abbr: 'ME', name: 'Maine' },
    { abbr: 'MD', name: 'Maryland' },
    { abbr: 'MA', name: 'Massachusetts' },
    { abbr: 'MI', name: 'Michigan' },
    { abbr: 'MN', name: 'Minnesota' },
    { abbr: 'MS', name: 'Mississippi' },
    { abbr: 'MO', name: 'Missouri' },
    { abbr: 'MT', name: 'Montana' },
    { abbr: 'NE', name: 'Nebraska' },
    { abbr: 'NV', name: 'Nevada' },
    { abbr: 'NH', name: 'New Hampshire' },
    { abbr: 'NJ', name: 'New Jersey' },
    { abbr: 'NM', name: 'New Mexico' },
    { abbr: 'NY', name: 'New York' },
    { abbr: 'NC', name: 'North Carolina' },
    { abbr: 'ND', name: 'North Dakota' },
    { abbr: 'OH', name: 'Ohio' },
    { abbr: 'OK', name: 'Oklahoma' },
    { abbr: 'OR', name: 'Oregon' },
    { abbr: 'PA', name: 'Pennsylvania' },
    { abbr: 'RI', name: 'Rhode Island' },
    { abbr: 'SC', name: 'South Carolina' },
    { abbr: 'SD', name: 'South Dakota' },
    { abbr: 'TN', name: 'Tennessee' },
    { abbr: 'TX', name: 'Texas' },
    { abbr: 'UT', name: 'Utah' },
    { abbr: 'VT', name: 'Vermont' },
    { abbr: 'VA', name: 'Virginia' },
    { abbr: 'WA', name: 'Washington' },
    { abbr: 'WV', name: 'West Virginia' },
    { abbr: 'WI', name: 'Wisconsin' },
    { abbr: 'WY', name: 'Wyoming' }
  ];

  // State Selected
  stateSelectedObj;

  // For Spinner
  searchProgress = false;

  // Error Fetching Data?
  errorFetching = false;

  // Screen NGRX Store State
  currentUserUIScreen;

  // Keep track of subscriptions to unsubscribe
  subscriptions: Subscription[] = [];

  // download component
  downloads: any;

  //are we mobile
  displayingMobile = false;

  // graph modal
  basicModalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private tableService: TableDataService,
    private store: Store<any>
  ) {
    this.subscriptions.push(
      store.select('currentUser').subscribe(
        currentUser => {
          this.currentUserUIScreen = currentUser;
          this.setTableControlsOpen(currentUser);
        },
        error => {
          console.error(error);
        }
      )
    );
  }

  @HostListener('window:resize', ['$event'])
  onReSize(event) {
    if (event.target.innerWidth <= 990 && !this.displayingMobile) {
      this.filterYearDropDownForMobile();
    }

    if (event.target.innerWidth >= 991 && this.displayingMobile) {
      this.filterYearDropDownForDesktop();
    }
  }

  filterYearDropDownForMobile() {
    let yearsToDisplayMobile = this.yearsToDisplay.map(function(yearObj) {
      if (yearObj.abbr !== '2020' && yearObj.abbr !== '2021') {
        yearObj.checked = false;
      }
      return yearObj;
    });

    this.yearsToDisplay = yearsToDisplayMobile;
    this.displayingMobile = true;
    this.addYearRemoveYear();
  }

  filterYearDropDownForDesktop() {
    let yearsToDisplayMobile = this.yearsToDisplay.map(function(yearObj) {
      if (yearObj.abbr !== '2015' && yearObj.abbr !== '2016') {
        yearObj.checked = true;
      }
      return yearObj;
    });

    this.yearsToDisplay = yearsToDisplayMobile;
    this.displayingMobile = false;
    this.addYearRemoveYear();
  }

  ngOnInit() {
    // Set Original State to Illinois
    this.stateSelectedObj = this.states[13];
    this.getTableData(this.stateSelectedObj.abbr);
    this.checkIfMobileScreen();
  }

  stopYearDropDownFromClosing(e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  checkIfMobileScreen() {
    if (document.documentElement.clientWidth < 990) {
      this.filterYearDropDownForMobile();
    } else {
      this.filterYearDropDownForDesktop();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      if (typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    });
  }

  onChangeSelect(e, index) {
    e.preventDefault();
    this.stateSelectedObj = this.states[index];
    this.getTableData(this.stateSelectedObj.abbr);
  }

  setTableControlsOpen(currentUser) {
    this.tableControlsOpen = currentUser.tableControlsOpen;
  }

  getTableData(value) {
    let searchOpts = {
      tableId: 'state',
      startYear: '2018',
      endYear: '2022',
      state: value
    };

    this.searchProgress = true;
    this.subscriptions.push(
      this.tableService.getSystem(searchOpts).subscribe(
        ({ data }) => {
          this.searchProgress = false;
          this.default_response = data.getTableData;
          this.paragraphText = this.default_response.tableDetails
            .replace(/\>\s+\</g, '><')
            .replace(/(\r\n|\n|\r)/gm, '')
            .trim();
          const htmlArray = this.default_response.tableTitle.split(':');
          this.header = htmlArray[0];
          this.subHeader = htmlArray[1];
          this.downloads = this.default_response.download;
          this.buildTableSections(data.getTableData);
          this.errorFetching = false;
        },
        error => {
          console.error('error fetching from graphql', error);
          this.searchProgress = false;
          this.errorFetching = true;
        }
      )
    );
  }

  toggleOverviewHeader() {
    this.overviewHeaderOpen = !this.overviewHeaderOpen;
  }

  toggleOverviewTable() {
    this.overViewTableOpen = !this.overViewTableOpen;
  }

  toggleFacilityTable() {
    this.totalFacilityTableOpen = !this.totalFacilityTableOpen;
  }

  togglehospitalUnitTable() {
    this.hospitalUnitTableOpen = !this.hospitalUnitTableOpen;
  }

  toggleCommunityHealthTable() {
    this.communityHealthTableOpen = !this.communityHealthTableOpen;
  }

  expandAll() {
    this.overviewHeaderOpen = true;
    this.store.dispatch({
      type: OPEN_ALL_SECTIONS,
      payload: {
        allSectionsOpen: true
      }
    });
  }

  collapseAll() {
    this.overviewHeaderOpen = false;
    this.store.dispatch({
      type: OPEN_ALL_SECTIONS,
      payload: {
        allSectionsOpen: false
      }
    });
  }

  buildTableSections(response) {
    this.table6Overview = response.tableData.section[0];
    this.table6TotalFacilitySection = response.tableData.section[1];
    this.table6HospitalUnitSection = response.tableData.section[2];
    this.table6CommunityHealthIndicators = response.tableData.section[3];
    //we bring back couple of years but we call this function to remove years, marked as checked false on yearsToDisplay
    this.addYearRemoveYear();
  }

  addYearRemoveYear() {
    //todo same as other tables use object assign instead of lodash

    if (!_.isEmpty(this.default_response)) {
      let tempTable = _.cloneDeep(this.default_response);
      let newtable6Overview = tempTable.tableData.section[0];
      let newtable6TotalFacilitySection = tempTable.tableData.section[1];
      let newtable6HospitalUnitSection = tempTable.tableData.section[2];
      let newtable6CommunityHealthIndicators = tempTable.tableData.section[3];

      this.table6Overview = this.filterTableSection(newtable6Overview);
      this.table6TotalFacilitySection = this.filterTableSection(newtable6TotalFacilitySection);
      this.table6HospitalUnitSection = this.filterTableSection(newtable6HospitalUnitSection);
      this.table6CommunityHealthIndicators = this.filterTableSection(
        newtable6CommunityHealthIndicators
      );
    }
  }

  filterTableSection(section) {
    let yearsToRemoveFromTable = this.yearsToDisplay
      .filter(year => year.checked === false)
      .map(year => year.abbr);

    // only the first section has this header
    if (section.row !== null) {
      section.row = section.row.map(function(obj) {
        let newHeaderRowObj = {};
        newHeaderRowObj['label'] = obj.label;
        newHeaderRowObj['cell'] = obj.cell.filter(function(cell) {
          return !_.includes(yearsToRemoveFromTable, cell.year);
        });
        return newHeaderRowObj;
      });
    }
    section.subsection = section.subsection.map(function(obj) {
      let newObj = {};
      newObj['label'] = obj.label;
      newObj['row'] = obj.row.map(function(row) {
        let rowObj = {};
        rowObj['label'] = row.label;
        rowObj['cell'] = row.cell.filter(function(cell) {
          return !_.includes(yearsToRemoveFromTable, cell.year);
        });
        return rowObj;
      });
      return newObj;
    });
    return section;
  }

  refresh() {
    window.location.reload();
  }

  openGraph(rowData) {
    // we are mapping two times we use concat all to remove inner array
    let dataForGraph = this.concatAll(
      rowData.row.map(mainObj =>
        mainObj.cell.map(cell => {
          return {
            year: cell.year,
            value: parseFloat(cell.value.replace(/,/g, ''))
          };
        })
      )
    ).reverse();

    this.basicModalRef = this.modalService.show(GraphModalComponent);
    this.basicModalRef.content.title = rowData.row.map(i => i.label)[0];
    this.basicModalRef.content.yLabel = '';
    this.basicModalRef.content.startingY = Math.min(...dataForGraph.map(i => i.value)) * 0.9;

    this.basicModalRef.content.dataForGraph = dataForGraph;
  }

  concatAll(nestedArrs) {
    let results = [];
    nestedArrs.forEach(subArr => subArr.forEach(i => results.push(i)));
    return results;
  }
}



// WEBPACK FOOTER //
// ./src/app/t6-states/states.component.ts